
<mat-dialog-content class="dark">

  <mat-form-field class="w-full">
    <mat-label>How did they answer?</mat-label>
    <mat-select [(ngModel)]="outcome" required>
      <mat-select-trigger>
        <span *ngIf="outcome == 'UNANSWERED'">
          <fa-icon icon="circle-minus"></fa-icon> Not answered
        </span>
        <span *ngIf="outcome == 'CORRECT'" class="text-positive">
          <fa-icon icon="circle-check"></fa-icon> Answered correctly
        </span>
        <span *ngIf="outcome == 'INCORRECT'" class="text-negative">
          <fa-icon icon="times-circle"></fa-icon> Answered incorrectly
        </span>
      </mat-select-trigger>
      <mat-option value="UNANSWERED">
        <span>
          <fa-icon icon="circle-minus"></fa-icon> Not answered
        </span>
      </mat-option>
      <mat-option value="CORRECT" class="text-positive">
        <span class="text-positive">
          <fa-icon icon="circle-check"></fa-icon> Answered correctly
        </span>
      </mat-option>
      <mat-option value="INCORRECT" class="text-negative">
        <span class="text-negative">
          <fa-icon icon="times-circle"></fa-icon> Answered incorrectly
        </span>
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="w-full">
    <mat-label>Why is this adjustment needed?</mat-label>
    <textarea matInput rows="5" [(ngModel)]="explanation" name="explanation"></textarea>
  </mat-form-field>

</mat-dialog-content>

<mat-dialog-actions class="text-right">
  <button class="w-full" mat-flat-button color="primary" [disabled]="!canConfirm" (click)="confirm()">
    Make adjustment
  </button>
</mat-dialog-actions>
